export const Home = "/";
export const Browse = "/browse";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin"; 